<template>
	 <v-container>
		 <v-dialog title="插班补课" v-model="hideShow" width="600px" persistent>
			<v-card>
				<v-card-title>
					<span>插班补课</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						<v-col cols="12">
							<v-select v-model="add.classId" :items="classItems" label="选择班级" item-text="className"
								item-value="id" outlined dense no-data-text="该课程暂无其它班级" @change="slectedClass"></v-select>
						</v-col>
						
						<v-col cols="12">
							<v-select v-model="add.recordId" :items="recordItems" label="选择课次" item-text="text"
								item-value="id" outlined dense no-data-text="暂无排课记录"></v-select>
						</v-col>
						
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitAdd" :loading="add.submiting" color="success">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
	 </v-container>
</template>

<script>

	import utils from "../config/utils"
	export default {
		name:"make-up-missed-lesson",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			recordDetail:{
				type:Object,
				default:{}
			}
		},
		watch:{
			show(newVal,oldVal){
				console.log("create student show=",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					this.add.classId = "";
					this.add.recordId = "";
					this.classItems = [];
					this.recordItems = [];
					this.getCourseClassList();
				}
			}
		},
		data(){
			return {
				shopId:"",
				add: {
					submiting:false,
					classId:"",
					recordId:""
				},
				
				hideShow:this.show,
				classItems:[],
				recordItems:[]
			}
		},
		mounted() {
			console.log("make-up-missed-lesson mounted");
			this.shopId = utils.getCurrentShopId(); 
			
			
		},
		methods:{
			
			cancel(){
				this.$emit("cancel","");
			},
			slectedClass(){
				this.getClassRecordList();
			},
			submitAdd() {
				
				if (!this.add.classId) {
					this.$noty.error('班级不能为空');
					return
				}
				if (!this.add.recordId) {
					this.$noty.error('课次不能为空');
					return
				}
				
				this.add.submiting = true;
				// api
				const that = this;
				let url = `/edu/class/record/extra/student/add`;
				let postData = {
					classId:this.add.classId,
					recordId:this.add.recordId,
					detailId:this.recordDetail.id,
				};
				postData.shopId = this.shopId;
						
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.add.submiting = false;
							that.$noty.success("添加成功");
							that.$emit("success","");
							
							return;
						} else {
							that.add.submiting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submiting = false;
						that.$noty.error('网络请求失败');
					}
			
				});
			
			},
			getCourseClassList(){
				const courseId = this.recordDetail.courseId;
				// api
				const that = this;
				let url = `/edu/course/all/class/list/${courseId}`;	
				this.classItems = [];
				this.axios.get(url).catch(() => {
					
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							
							const result = res.data["data"]||[];
							
							result.forEach((item,index)=>{
								if(item.id != this.recordDetail.classId){
									that.classItems.push({id:item.id,className:item.className});
								}
							})
							
							
							return;
						} 
					} 
							
				});
			},
			getClassRecordList(){
				const classId = this.add.classId;
				// api
				const that = this;
				let url = `/edu/class/record/list/for/buke/${classId}`;	
				
				this.axios.get(url).catch(() => {
					
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							
							const result = res.data["data"]||[];
							
							console.log('class list',result);
							
							that.recordItems = result;
							
							
							return;
						} 
					} 
							
				});
			},
		}
	}
	
</script>

<style>
</style>
